import { render, staticRenderFns } from "./UserAddNew.vue?vue&type=template&id=7148bd64&scoped=true&"
import script from "./UserAddNew.vue?vue&type=script&lang=js&"
export * from "./UserAddNew.vue?vue&type=script&lang=js&"
import style0 from "./UserAddNew.vue?vue&type=style&index=0&id=7148bd64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7148bd64",
  null
  
)

export default component.exports